/* eslint-disable */
// ** Icons Import
import { Home, Circle } from "react-feather";

export default [
  {
    id: "dashboards",
    title: "Dashboards",
    icon: <Home size={20} />,
    badge: "light-warning",
    badgeText: "1",
    children: [
      // {
      //   id: "analyticsDash",
      //   title: "Analytics",
      //   icon: <Circle size={12} />,
      //   navLink: "/dashboard/analytics",
      // },
      {
        id: "Reports",
        title: "Reports",
        icon: <Circle size={12} />,
        navLink: "/dashboard/ecommerce",
      },
    ],
  },
];
